import { styled } from '@mui/material/styles'

export const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  margin: '50px 0px',
  padding: '0px 25px',
})

export const Title = styled('h1')(({ theme }) => ({
  fontSize: '2.5rem',
  fontWeight: 'bold',
  color: theme.palette.text.primary,
}))

export const Subtitle = styled('h1')(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 400,
  color: theme.palette.text.secondary,
}))

export const Details = styled('h1')(({ theme }) => ({
  marginTop: '2rem',
  fontSize: '1rem',
  fontWeight: 600,
  color: theme.palette.error.main,
}))
